
/**
 * Returns a debounced version of the given function.
 * Debouncing is a performance optimization technique that
 * ensures a function is only called after a certain amount
 * of time has passed since the last time the function was called.
 * This can be especially useful for functions that are
 * called rapidly, such as on window resizes or on keypresses.
 *
 * @param {Function} func The function to debounce.
 * @param {Number} timeout The amount of time to debounce in milliseconds.
 * @returns {Function} The debounced version of the given function.
 */
const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export default debounce;